import React from "react";
import { Routes, Route } from "react-router-dom";
import DashboardHome from "./DashboardHome";
import AdminContactus from "./AdminContactus";
import Development from "./Development";
import DevelopmentForm from "./DevelopmentForm";
import CMRFTable from "./CMRFTable";
import CmrFundsForm from "./CmrFundsForm";
import Mp3Table from "./Mp3Table";
import Mp3Form from "./Mp3Form";
import Mp4Table from "./Mp4Table";
import Mp4Form from "./Mp4Form";
import BeneficiariesForm from "./BeneficiariesForm";
import BeneficiariesTable from "./BeneficiariesTable";
import Voters from "./Voters";
import AdaBiddaNidhi from "./AdaBiddaNidhi";
import AdaBiddaNidhiForm from "./AdaBiddaNidhiForm";
import ThallikiVandanamForm from "./ThallikiVandanamForm";
import ThallikiVandanamTable from "./ThallikiVandanamTable";
import DeepamSchemeForm from "./DeepamSchemeForm";
import DeepamSchemeTable from "./DeepamSchemeTable";
import MahaShakthiForm from "./MahaShakthiForm";
import MahaShakthiTable from "./MahaShakthiTable";
import AnnadataSukhibhavaForm from "./AnnadataSukhibhavaForm";
import AnnadataSukhibhavaTable from "./AnnadataSukhibhavaTable";
import YuvagalamForm from "./YuvagalamForm";
import YuvagalamTable from "./YuvagalamTable";
import SurveyFeedbackForm from "./SurveyFeedbackForm";
import SurveyFeedbackTable from "./SurveyFeedbackTable";
import EventsTable from "./EventsTable";
import EventsForm from "./EventsForm";
import ReportsPage from "./ReportsPage";
import NotesFollowUpForm from "./NotesFollowUpForm";
import NotesFollowUpTable from "./NotesFollowUpTable";
import JanataDarbarTable from "./JanataDarbarTable";
import JanataDarbarForm from "./JanataDarbarForm";
import SettingsPage from "./SettingsPage";
import BeneficiaryLookup from "./BeneficiaryLookup";
import LocalLeadersTable from "./LocalLeadersTable";
import LocalLeadersForm from "./LocalLeadersForm";
import GalleryTable from "./GalleryTable";
import GalleryForm from "./GalleryForm";
import PressForm from "./PressForm";
import PressTable from "./PressTable";
import CommunicationDashboard from "./CommunicationDashboard";
import PoliticalSurveyWarRoom from "./PoliticalSurveyWarRoom";
import PollingBoothManagement from "./PollingBoothManagement";
import BoothsTable from "./BoothsTable";


function DashboardRoutes() {
  return (
    <Routes>
      <Route path="/" element={<DashboardHome/>} />
      <Route path="/dashboard-home" element={<DashboardHome/>} />
      <Route path="/voters" element={<Voters/>} />
      <Route path="/admincontact" element={<AdminContactus/>} />
      <Route path="/development" element={<Development/>} />
      <Route path="/development-form" element={<DevelopmentForm/>} />
      <Route path="/cmrf-table" element={<CMRFTable/>} />
      <Route path="/cmrf-form" element={<CmrFundsForm/>} />
      <Route path="/mp3-table" element={<Mp3Table/>} />
      <Route path="/mp3-form" element={<Mp3Form/>} />
      <Route path="/mp4-table" element={<Mp4Table/>} />
      <Route path="/mp4-form" element={<Mp4Form/>} />
      <Route path="/beneficiaries-table" element={<BeneficiariesTable/>} />
      <Route path="/beneficiaries-form" element={<BeneficiariesForm/>} />
      <Route path="/AdaBiddaNidhi" element={<AdaBiddaNidhi/>} />
      <Route path="/AdaBiddaNidhiForm" element={<AdaBiddaNidhiForm/>} />

       <Route path="/ThallikiVandanamForm" element={<ThallikiVandanamForm/>} />
        <Route path="/ThallikiVandanamTable" element={<ThallikiVandanamTable/>} />

      <Route path="/DeepamSchemeForm" element={<DeepamSchemeForm/>} />
      <Route path="/DeepamSchemeTable" element={<DeepamSchemeTable/>} />

      <Route path="/MahaShakthiForm" element={<MahaShakthiForm/>} />
      <Route path="/MahaShakthiTable" element={<MahaShakthiTable/>} />

      <Route path="/AnnadataSukhibhavaForm" element={<AnnadataSukhibhavaForm/>} />
<Route path="/AnnadataSukhibhavaTable" element={<AnnadataSukhibhavaTable/>} />

<Route path="/YuvagalamForm" element={<YuvagalamForm/>} />
<Route path="/YuvagalamTable" element={<YuvagalamTable/>} />

<Route path="/SurveyFeedbackForm" element={<SurveyFeedbackForm/>} />
<Route path="/SurveyFeedbackTable" element={<SurveyFeedbackTable/>} />

<Route path="/EventsTable" element={<EventsTable/>} />
<Route path="/EventsForm" element={<EventsForm/>} />

<Route path="/ReportsPage" element={<ReportsPage/>} />

<Route path="/NotesFollowUpForm" element={<NotesFollowUpForm/>} />
<Route path="/NotesFollowUpTable" element={<NotesFollowUpTable/>} />

<Route path="/JanataDarbarTable" element={<JanataDarbarTable/>} />
<Route path="/JanataDarbarForm" element={<JanataDarbarForm/>} />

<Route path="/SettingsPage" element={<SettingsPage/>} />


<Route path="/BeneficiaryLookup" element={<BeneficiaryLookup/>} />
<Route path="/LocalLeadersTable" element={<LocalLeadersTable/>} />
<Route path="/LocalLeadersForm" element={<LocalLeadersForm/>} />


<Route path="/GalleryTable" element={<GalleryTable/>} />
<Route path="/GalleryForm" element={<GalleryForm/>} />

<Route path="/PressForm" element={<PressForm/>} />
<Route path="/PressTable" element={<PressTable/>} />

<Route path="/CommunicationDashboard" element={<CommunicationDashboard/>} />


<Route path="/PoliticalSurveyWarRoom" element={<PoliticalSurveyWarRoom/>} />

<Route path="/PollingBoothManagement" element={<PollingBoothManagement/>} />


<Route path="/BoothsTable" element={<BoothsTable/>} />

  

    </Routes>
  );
}

export default DashboardRoutes;
